// 面包屑中的 “添加管理员” 是活的  需要从VUEX中获取  切记
// 需要在VUEX中定义一个变量，添加时为false，修改时为true  修改是用户账号是不允许改的
// 引入axios组件
import axios from 'axios';
import qs from 'qs'; // 处理数据  qs.stringify(params)
import { checkRule } from '@/assets/js/public';
// 引入公共js文件
export default {
  data() {
    return {
      username: '',
      password: '',
      again_password: '',
      admintitle: '',
      adminparam: '',
      // ueState:false,//角色下拉列表状态
      categorylist: [], // 角色下拉列表数组
      gid: '', // 用户角色id
    };
  },
  // computed:{
  //   username:{
  //     get(a){
  //       console.log(a)
  //       // return this.adminparam.username || "";
  //     },
  //     set(){
  //     }
  //   },
  // },
  // 创建vue之后的生命周期函数
  created() {
    const userid = this.$route.query.userid;
    const self = this;
    axios({
      method: 'post',
      url: '/admin/admin/adminEdit',
      data: { userid },
    })
      .then((response) => {
        checkRule(response, self); // 检查是否有权限

        if (userid) {
          self.adminparam = response.data.admininfo;
          self.username = self.adminparam.username;
          self.gid = self.adminparam.gid;
        }
        self.categorylist = response.data.adminrole;
      })
      .catch((response) => {});
    if (userid) {
      self.admintitle = '修改管理员';
    } else {
      this.admintitle = '添加管理员';
    }
  },
  methods: {
    // 返回方法
    adminReturn() {
      this.$router.push({
        path: '/admin', // 这是路由名称
      });
    },
    // 提交添加/修改方法，提交之前需要判断提交的数据是否合法
    adminUpdate() {
      if (this.password.length < 6) {
        this.$Message.warning('密码不能少于六位');
        return false;
      } else if (this.password != this.again_password) {
        this.$Message.warning('两次密码输入不一致');
        return false;
      } else if (this.username == '') {
        this.$Message.warning('账号不能为空');
        return false;
      }
      const self = this;
      // var userid = localStorage.userid;
      const userid = this.$route.query.userid || ''; // 定义一个变量存储路由带过来的值
      axios({
        method: 'post',
        url: '/admin/admin/adminUpdate',
        data: {
          username: self.username,
          password: self.password,
          userid,
          gid: self.gid,
        },
      })
        .then((response) => {
          checkRule(response, self); // 检查是否有权限

          if (response.data.code == 1) {
            self.$Message.success(response.data.msg);
            self.$router.push({
              path: '/admin', // 这是路由名称
            });
          } else {
            self.$Message.error(response.data.msg);
          }
        })
        .catch((response) => {
          // self.$Message.error('请求失败');
        });
    },
  },
};
